import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppRouter from './AppRouter';
import reportWebVitals from './reportWebVitals';
import { CarrinhoProvider } from './CarrinhoContext';
import { BrowserRouter } from 'react-router-dom'; // ✅ IMPORTANTE

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter> {/* ✅ Agora o contexto está presente */}
    
  <CarrinhoProvider>
  <AppRouter />
</CarrinhoProvider>

    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
